module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'mb-15': _vm.isMissingMemo || _vm.hasPaymentError || _vm.isRestricted || (!_vm.isEnabled && !_vm.isEnabledOnlyAutomatic) || _vm.isFresh || (_vm.isNotActivated && _vm.coin === 'XRP')
    }
  }, [(_vm.isMissingMemo) ? _c('div', {
    staticClass: "result-no-memo notification is-danger has-text-left fs-12"
  }, [_vm._m(0), _vm._m(1), _vm._m(2), _c('div', {
    staticClass: "fs-13 mt-10 wb-ba"
  }, [_c('b', {
    staticClass: "opacity-05"
  }, [_vm._v(_vm._s(_vm.coin))]), _c('b', {
    staticClass: "fredoka-style"
  }, [_vm._v(":")]), _c('b', {
    staticClass: "opacity-05"
  }, [_vm._v(_vm._s(_vm.address))]), _c('b', {
    staticClass: "fredoka-style"
  }, [_vm._v(":")]), _c('b', [_vm._v("YourPaymentID")]), _c('b', {
    staticClass: "fredoka-style"
  }, [_vm._v(".")]), _c('b', {
    staticClass: "opacity-05"
  }, [_vm._v("YourWorkerName")])]), _vm._m(3)]) : _vm._e(), (_vm.hasPaymentError) ? _c('div', {
    staticClass: "result-error-address notification is-danger has-text-left"
  }, [_vm._m(4), _vm._m(5), _vm._m(6), _vm._m(7)]) : _vm._e(), (_vm.isRestricted) ? _c('div', {
    staticClass: "result-restricted notification is-danger"
  }, [_vm._m(8)]) : _vm._e(), (!_vm.isDelisted && !_vm.isEnabled && !_vm.isEnabledOnlyAutomatic) ? _c('div', {
    staticClass: "result-maintenance notification is-info is-info-dark"
  }, [_c('p'), _c('div', [_c('span', [_vm._v("Payments for the " + _vm._s(_vm.chain.name) + " network are currently under maintenance")]), (_vm.maintenanceMessage) ? _c('span', [_c('span', [_vm._v(": ")]), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.maintenanceMessage)
    }
  })]) : _c('span', [_vm._v(". ")]), _c('u', [_vm._v("Mining is not affected!")])]), (_vm.chains.length > 1) ? _c('div', {
    staticClass: "multi-chain-support"
  }, [_c('span', [_vm._v("You may try another network, we also support payouts through the ")]), _c('span', {
    staticClass: "multi-chains"
  }, _vm._l((_vm.chainsWithoutCurrent), function(item, index) {
    return _c('span', [(index > 0 && index === _vm.chainsWithoutCurrent.length - 1) ? _c('span', [_vm._v(" and ")]) : _vm._e(), _c('span', [_vm._v(_vm._s(item.name) + " (" + _vm._s(item.token_standard) + ")")]), (index < _vm.chainsWithoutCurrent.length - 2) ? _c('span', [_vm._v(", ")]) : _vm._e()])
  }), 0), _c('span', [_vm._v(" chains.")])]) : _vm._e(), _c('p')]) : _vm._e(), (_vm.isDelisted) ? _c('div', {
    staticClass: "result-maintenance notification is-danger is-danger-dark"
  }, [_c('p'), _vm._m(9), _c('p')]) : _vm._e(), (_vm.isFresh) ? _c('div', {
    staticClass: "result-new-address notification is-info is-info-dark has-text-left"
  }, [_vm._m(10), _c('div', {
    staticClass: "mt-10"
  }, [_c('p', {
    staticClass: "mb-10"
  }, [_c('span', [_vm._v("To start use a compatible mining software and connect to any of our supported pools! You can find some examples in the  ")]), _c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_vm._v(" Start ")]), _c('span', [_vm._v(" option of the website.")])], 1), _c('p', {
    staticClass: "mb-10"
  }, [_c('span', [_vm._v("You could also share your Referral Code and  ")]), _c('router-link', {
    attrs: {
      "to": "/referrals"
    }
  }, [_vm._v(" start earning referral rewards right away!  ")]), _c('span', [_vm._v(" Even if you are not mining on your own.")])], 1), _vm._m(11), _vm._m(12)])]) : _vm._e(), (_vm.isNotActivated && _vm.coin === 'XRP') ? _c('div', {
    staticClass: "result-not-activated notification is-warning"
  }, [_vm._m(13)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-12"
  }, [_c('b', [_vm._v("You are mining to an exchange or third party wallet address with no Payment ID, Memo or Tag!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-13 mt-10"
  }, [_c('b', [_c('u', [_vm._v("Stop mining immediately as any mining reward associated to this address is unrecoverable and non transferable")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-12 mt-10"
  }, [_c('span', [_vm._v("You must add your Payment ID, Memo or Tag right after the address in the user param of your miner (followed by a : symbol), like this:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-10"
  }, [_c('span', [_vm._v("Otherwise we will be unable to pay your coins!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("There seems to be an issue with your address!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-10"
  }, [_c('p', [_c('b', [_vm._v("We tried to process your payment many times with no success.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-10"
  }, [_c('p', [_c('span', [_vm._v("This usually happens when there is a typo or incorrect capitalization in your address (most networks are case-sensitive). To resolve this, simply reconnect your miner using the correct capitalization, then try again after a few minutes.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-10"
  }, [_c('p', [_c('span', [_vm._v("If you are still having issues or your address has a wrong, extra or missing letter, kindly contact us for help")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', [_vm._v("Your address has been restricted from joining our platform due to suspected botnet, web mining, or similar activity. If you are operating a legitimate service or managing more than 100 active connections, please connect through port 4445 using a proxy (")]), _c('a', {
    attrs: {
      "href": "https://github.com/MoneroOcean/xmr-node-proxy",
      "target": "=_blank"
    }
  }, [_c('span', [_vm._v("xmr-node-proxy")]), _c('span', [_vm._v(" ")]), _c('i', {
    staticClass: "fa fa-external-link fs-12"
  })]), _c('span', [_vm._v(" or ")]), _c('a', {
    attrs: {
      "href": "https://github.com/xmrig/xmrig-proxy",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("xmrig-proxy")]), _c('span', [_vm._v(" ")]), _c('i', {
    staticClass: "fa fa-external-link fs-12"
  })]), _c('span', [_vm._v(").")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b', [_vm._v("This coin or token has been delisted and no further rewards will be credited.")]), _c('br'), _c('span', [_vm._v("For more information kindly check the News section or our ")]), _c('a', {
    attrs: {
      "href": "https://x.com/un_mineable",
      "target": "_blank"
    }
  }, [_vm._v(" official X feed.")]), _c('br'), _c('br'), _c('span', [_vm._v("Be sure to point your workers to another coin!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-16"
  }, [_c('b', [_vm._v("Welcome to your stats!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb-10"
  }, [_c('span', [_vm._v("If you have any issue or suggestion please take a look at our ")]), _c('a', {
    attrs: {
      "href": "https://unmineable.com/support"
    }
  }, [_vm._v("Support Center.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb-10"
  }, [_c('span', [_vm._v("Happy mining!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', [_vm._v("Your XRP address is ")]), _c('b', [_vm._v("not activated. ")]), _c('span', [_vm._v("Your first payout will  ")]), _c('a', {
    attrs: {
      "href": "https://xrpl.org/reserves.html",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("activate your address ")]), _c('i', {
    staticClass: "fa fa-external-link-square"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-604d2161","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_stats_notification.vue
// module id = 382
// module chunks = 1